'use strict';

/**
 * Remove sidebar on click of links that are not dropdown links
 */
export var fnSidebarCloser = function () {
    $('.left-sidebar-1 a:not(.sidebar-dropdown)').on('click', function (e) {

        var leftSidebar = $('.left-sidebar-backdrop');

        leftSidebar.removeClass('fade');
        leftSidebar.removeClass('in');
        $('body').removeClass('layout-collapsed');
    })
}
